import { useParams } from 'react-router-dom';
import { resolveState } from '@/lib/usStates';
import { resolveMetro } from '@/lib/usMetros';
import EventsByStatePage from '@/pages/public/EventsByStatePage';
import EventsByCityPage from '@/pages/public/EventsByCityPage';
import EventDetailPage from '@/pages/member/EventDetailPage';

/**
 * Dispatcher for `/events/:slug` — chooses between three pages:
 *  1. City hub (`/events/atlanta-ga`)    — slug matches a known metro
 *  2. State hub (`/events/california`)   — slug matches a known state
 *  3. Event detail (`/events/<id>`)      — slug is treated as an event ID
 *
 * City check runs first because city slugs (e.g. `washington-dc`) can
 * superficially look like state slugs.
 */
export default function EventSlugRouter() {
  const { eventId } = useParams();
  if (resolveMetro(eventId || '')) return <EventsByCityPage />;
  if (resolveState(eventId || '')) return <EventsByStatePage />;
  return <EventDetailPage />;
}
